// @ts-strict-ignore
import { Component } from "@angular/core";
import { ProgressCheck } from "src/app/shared/models/progress-check.model";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import { DataService } from "src/app/shared/services/data.service";
import * as ProfileModel from "src/app/shared/models/profile.model";

@Component({
  selector: C.EWIZ_M2M_CONNECTIVITY_PARAMETERS_CONFIGURATION,
  templateUrl: "./m2m-connectivity-parameters-configuration.component.html",
  standalone: false
})
export class EWizM2MConnectivityParametersConfigurationComponent extends EWizDynamicBaseClassComponent implements ProgressCheck {
  progressCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    if (dataService.isNullOrEmpty(values.m2mConnectivityParameters.m2mRemoteProvisioningSystem)) {
      return false;
    } else if (+values.m2mConnectivityParameters.m2mRemoteProvisioningSystem === 1) {
      if (dataService.isNullOrEmpty(values.m2mConnectivityParameters.protocol)) {
        return false;
      }
      if (
        (+values.m2mConnectivityParameters.protocol === 1 || +values.m2mConnectivityParameters.protocol === 3) &&
        dataService.isNullOrEmpty(values.m2mConnectivityParameters.smsCenterAddress)
      ) {
        return false;
      }
      if (
        (+values.m2mConnectivityParameters.protocol === 2 || +values.m2mConnectivityParameters.protocol === 3) &&
        dataService.isNullOrEmpty(values.m2mConnectivityParameters.networkAccessName)
      ) {
        return false;
      }
      if (+values.m2mConnectivityParameters.protocol === 3 && dataService.isNullOrEmpty(values.m2mConnectivityParameters.priority)) {
        return false;
      }
    }

    return true;
  }
}
